import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton w-48 h-14" }, null, -1)
const _hoisted_2 = { class: "mt-12 space-y-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_OpenSourcePackageSkeleton = _resolveComponent("OpenSourcePackageSkeleton")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_Grid, null, {
        default: _withCtx(() => [
          _createVNode(_component_Column, { class: "mb-12" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (rows) => {
          return _createVNode(_component_OpenSourcePackageSkeleton, { key: rows })
        }), 64))
      ])
    ]),
    _: 1
  }))
}